/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import weisstechnikLogo from './Images/Logo-Weiss-Technik.jpg';

const StyledImg = styled.img`
  max-width: 15vw;
`;

export const Logo = () => <StyledImg src={weisstechnikLogo} alt='loading...' />;
export default Logo;
